export default "__VITE_ASSET__66a923ed__"